/*====== Define import ======*/
/*------ React ------*/
import React from "react";
import { Routes, Route } from "react-router-dom";
/*------ Material-UI ------*/
/*------ Material-UI Theme ------*/
/*------ Compornent Js/Jsx ------*/
import { BrowserRouter } from "react-router-dom";
import { PrivateRoute } from "04Routers/PrivateRoute";
import { GetTemp } from "01Pages/Template/GetTemp";
import { UpdateTemp } from "01Pages/Template/UpdateTemp";
import { RegisterTemp } from "01Pages/Template/RegisterTemp";
import { GetInformationDetail } from "01Pages/Employee/Information/GetInformationDetail";
import { GetInformationList } from "01Pages/Employee/Information/GetInformationList";
import { GetUserList } from "01Pages/Master/User/GetUserList";
import { GetRankList } from "01Pages/Master/Rank/GetRankList";
import { GetPositionList } from "01Pages/Master/Position/GetPositionList";
import { GetCostList } from "01Pages/Master/Cost/GetCostList";
import { GetDepartmentList } from "01Pages/Master/Department/GetDepartmentList";
import { GetStatusList } from "01Pages/Master/Status/GetStatusList";
import { GetApprovalList } from "01Pages/Employee/Approval/GetApprovalList";
import { GetContractList } from "01Pages/Employee/Contract/GetContractList";
import { GetHistoryEmployee } from "01Pages/Employee/Information/GetHistoryEmployee";
import { GetAssignedList } from "01Pages/Employee/Assigned/GetAssignedList";
import { GetAcceptedList } from "01Pages/Employee/Accepted/GetAcceptedList";
import { GetTemporaryList } from "01Pages/Employee/Temporary/GetTemporaryList";
import { GetAllItemList } from "01Pages/Employee/AllItem/GetAllItemList";
import { GetAppointmentList } from "01Pages/Employee/Appointment/GetAppointmentList";
import { GetDepartmentTransferList } from "01Pages/Employee/DepartmentTransfer/GetDepartmentTransferList";
import { GetCheckList } from "01Pages/Employee/Check/GetCheckList";
import { GetMoveInList } from "01Pages/Employee/MoveIn/GetMoveInList";
import { GetMoveOutList } from "01Pages/Employee/MoveOut/GetMoveOutList";
import { GetOrganizationCodeList } from "01Pages/Employee/OrganizationCode/GetOrganizationCodeList";
import { GetAuthorityList } from "01Pages/Master/Authority/GetAuthorityList";
import { GetGradeList } from "01Pages/Master/Grade/GetGradeList";
import { GetAuthXX } from "01Pages/Common/Auth/GetAuthXX";
import { CmnConfirm } from "01Pages/Common/Confirm/CmnConfirm";
import { UpdAllItem } from "01Pages/Employee/AllItem/UpdAllItem";
import { OutAllItem } from "01Pages/Employee/AllItem/OutAllItem";
import { RegAllItem } from "01Pages/Employee/AllItem/RegAllItem";
import { FmtInformations } from "01Pages/Employee/Information/FmtInformation";
import { FmtDepartment } from "01Pages/Master/Department/FmtDepartment";
import { RegDepartment } from "01Pages/Master/Department/RegDepartment";
import { UpdDepartment } from "01Pages/Master/Department/UpdDepartment";
import { GetAuth01 } from "01Pages/Common/Auth/GetAuth01";
import { AUTHCA } from "01Pages/Common/Auth/AUTHCA";
import { AUTHCT } from "01Pages/Common/Auth/AUTHCT";
import { GetAuth02 } from "01Pages/Common/Auth/GetAuth02";
import { LOGOUT } from "01Pages/Common/Auth/LOGOUT";


/*====== Define global variables/functions   ======*/
// const consoleLogOutput = false;	//コンソールログ個別出力制御用

/*====================*/
/*======  Main  ======*/
/*====================*/
const App = () => {
	// outputLog('App IN', consoleLogOutput);
	/*------  Instance作成 ------*/
	// const apiData = useProvideData();		//APIデータ取得

	/*------ 認証情報の取得 ------*/
	// const auth = useAuth();
	// // 認証の確認中
	// if (auth.isLoading) {
	// 	return <LoadingProgressBar open={true}/>;
	// }

	// outputLog('App OUT(normal)', consoleLogOutput);

	return (
		<>
			<BrowserRouter>
				<Routes>
					<Route
						// path='/'
						element={<GetAuthXX />}
					/>
					{/* AD認証 */}
					<Route 
						path='/'
						element={<GetAuth01 />}
					/>
					{/* cognito認証 */}
					<Route 
						path='/authca'
						element={<AUTHCA />}
					/>
					{/* cognito token取得 */}
					<Route 
						path='/authct'
						element={<AUTHCT />}
					/>
					{/* 認可 */}
					<Route
						path='/common/auth02'
						element={<GetAuth02 />}
					/>
					{/* ログアウト */}
					<Route 
						path='/common/logout'
						element={<LOGOUT />}
					/>
					{/* 詳細テンプレート */}
					<Route
						path='/gettemp'
						element={<PrivateRoute children={<GetTemp />} />}
					/>
					{/* 編集テンプレート */}
					<Route
						path='/updatetemp'
						element={<PrivateRoute children={<UpdateTemp />} />}
					/>
					{/* 登録テンプレート */}
					<Route
						path='/registertemp'
						element={<PrivateRoute children={<RegisterTemp />} />}
					/>
					{/* 完了テンプレート */}
					<Route
						path='/common/completion'
						element={<PrivateRoute children={<CmnConfirm />} />}
					/>
					{/* ====== Employ ====== */}
					{/* 全従業員 */}
					<Route
						path='/employee/allitem/list'
						element={<PrivateRoute children={<GetAllItemList />} />}
					/>
					<Route
						path='/employee/allitem/update'
						element={<PrivateRoute children={<UpdAllItem/>} />}
					/>
					<Route
						path='/employee/allitem/output'
						element={<PrivateRoute children={<OutAllItem/>} />}
					/>			
					<Route
					path='/employee/allitem/register'
					element={<PrivateRoute children={<RegAllItem />} />}
					/>

					{/* 新規任用・解任表示 */}
					<Route
						path='/employee/appointment/list'
						element={<PrivateRoute children={<GetAppointmentList />} />}
					/>
					{/* 契約社員データ表示 */}
					<Route
						path='/employee/contract/list'
						element={<PrivateRoute children={<GetContractList />} />}
					/>
					{/*部署移動*/}
					<Route
						path='/employee/departmenttransfer/list'
						element={<PrivateRoute children={<GetDepartmentTransferList />} />}
					/>
					{/* 従業員一覧 */}
					<Route
						path='/employee/information/list'
						element={<PrivateRoute children={<GetInformationList />} />}
					/>
					<Route
						path='/employee/information/detail'
						element={<PrivateRoute children={<GetInformationDetail />} />}
					/>
					<Route
						path='/employee/information/format'
						element={<PrivateRoute children ={<FmtInformations/>}/>}
					/>
					<Route
						path='/employee/historyemployees'
						element={<PrivateRoute children ={<GetHistoryEmployee/>}/>}
					/>
					{/* 従業員一覧チェックリスト */}
					<Route
						path='/employee/check/list'
						element={<PrivateRoute children={<GetCheckList />} />}
					/>
					{/* 人事稟議一覧 */}
					<Route
						path='/employee/approval/list'
						element={<PrivateRoute children={<GetApprovalList />} />}
					/>
					{/* 権限グループマスタメンテ */}
					<Route
						path='/master/authority/list'
						element={<PrivateRoute children={<GetAuthorityList />} />}
					/>
					{/* 部署マスタメンテ */}
					<Route
						path='/master/department/list'
						element={<PrivateRoute children={<GetDepartmentList />} />}
					/>
					<Route
						path='/master/department/format'
						element={<PrivateRoute children ={<FmtDepartment/>}/>}
					/>
					<Route
                        path='/master/department/update'
                        element={<PrivateRoute children={<UpdDepartment/>} />}
                    />
                    <Route
                        path='/master/department/register'
                        element={<PrivateRoute children={<RegDepartment/>} />}
                    />
					{/* 雇用形態マスタメンテ */}
					<Route
						path='/master/status/list'
						element={<PrivateRoute children={<GetStatusList />} />}
					/>
					{/* 等級マスタメンテ */}
					<Route
						path='/master/grade/list'
						element={<PrivateRoute children={<GetGradeList />} />}
					/>
					{/* 人件費区分マスタメンテ */}
					<Route
						path='/master/cost/list'
						element={<PrivateRoute children={<GetCostList />} />}
					/>
					{/* 役職マスタメンテ */}
					<Route
						path='/master/position/list'
						element={<PrivateRoute children={<GetPositionList />} />}
					/>
					{/* ランクマスタメンテ */}
					<Route
						path='/master/rank/list'
						element={<PrivateRoute children={<GetRankList />} />}
					/>
					{/* ユーザーマスタメンテ */}
					<Route
						path='/master/user/list'
						element={<PrivateRoute children={<GetUserList />} />}
					/>
					{/* 転入日一覧表示 */}
					<Route
						path='/employee/movein/list'
						element={<PrivateRoute children={<GetMoveInList />} />}
					/>
					{/* 転出日一覧表示 */}
					<Route
						path='/employee/moveout/list'
						element={<PrivateRoute children={<GetMoveOutList />} />}
					/>
					{/* 組織コード一覧表示 */}
					<Route
						path='/employee/organizationcode/list'
						element={<PrivateRoute children={<GetOrganizationCodeList />} />}
					/>
					{/* 出向社員(出)情報 */}
					<Route
						path='/employee/assigned/list'
						element={<PrivateRoute children={<GetAssignedList />} />}
					/>
					{/* 出向社員(受)情報 */}
					<Route
						path='/employee/accepted/list'
						element={<PrivateRoute children={<GetAcceptedList />} />}
					/>
					{/* 派遣社員情報 */}
					<Route
						path='/employee/temporary/list'
						element={<PrivateRoute children={<GetTemporaryList />} />}
					/>
				</Routes>
			</BrowserRouter>
		</>
	);
};

export default App;
